var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1997 5.9875V3.42667C11.1997 2.94833 10.838 2.40583 10.3889 2.225L7.13969 0.895C6.41052 0.5975 5.58802 0.5975 4.85885 0.895L1.60969 2.225C1.16635 2.40583 0.804688 2.94833 0.804688 3.42667V5.9875C0.804688 8.84 2.87552 11.5117 5.70469 12.2933C5.89719 12.3458 6.10719 12.3458 6.29969 12.2933C9.12885 11.5117 11.1997 8.84 11.1997 5.9875ZM6.43969 7.00833V8.5425C6.43969 8.78167 6.24135 8.98 6.00219 8.98C5.76302 8.98 5.56469 8.78167 5.56469 8.5425V7.00833C4.97552 6.82167 4.54385 6.27333 4.54385 5.62583C4.54385 4.82083 5.19719 4.1675 6.00219 4.1675C6.80719 4.1675 7.46052 4.82083 7.46052 5.62583C7.46052 6.27917 7.02885 6.82167 6.43969 7.00833Z",
    fill: "#600DB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.01e31778a2e73085be466291addd434e.svg";
export { ForwardRef as ReactComponent };